import {useEditorValidate} from "@/main-page/gridCellEditor/validate/useEditorValidate";
import {nextTick, unref} from "vue";
import {StorageUtils} from "xmgoing-utils";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import eventBus from "@/events/eventBus";
import {formatFloatNumberValue} from "@/main-page-form/ctls/baseCtls/FloatNumber/hooks/useFloatNumberCtl";
import GoingUtils from "@/utils/goingUtils";
import {useGridTableStore} from "@/store/modules/gridTableStore";

export const executeColEvent = function ({
                                           column,
                                           record,
                                           formDomainObj,
                                           emits
                                         }, clickEvent, clickEventByItem) {
  try {
    if (unref(column) && unref(column).changFun && typeof unref(column).changFun === 'function') {
      unref(column).changFun && unref(column).changFun(unref(record), unref(formDomainObj), unref(record)[unref(column).dataIndex]);
    }
  } catch (e) {
    console.error(e, "============sss")
  }

  try {
    //如果存在事件
    if (unref(column).jsContent) {
      clickEventByItem({jsContent: unref(column).jsContent}, {
        formObj: unref(formDomainObj),
        record: unref(record),
        value: unref(record)[unref(column).dataIndex],
        column: unref(column)
      });
    }
  } catch (e) {
    console.error(e, "============sss")
  }

  if (unref(column).events && Array.isArray(unref(column).events) && unref(column).events.length > 0) {
    clickEvent('change', {
      formObj: unref(formDomainObj),
      record: unref(record),
      value: unref(record)[unref(column).dataIndex],
      column: unref(column)
    })
  }
}

export function useCellEditorComHooks({
  emits,
  validate,
  gridKey = '',
  formDomainObj,
  column,
  record,
  index,
}) {
  const {hasError, errorMsg, validateAll} = useEditorValidate({emits, validate, column, record, index});
  const {clickEventByItem, clickEvent} = useComEvent({events: unref(column).events || []});
  const changeFlag = ref(true);
  // 标记是否正在用户输入
  const isUserTyping = ref(false);

  const initColChangeFun = function () {
    if (unref(column)['changFun'] && typeof unref(column)['changFun'] === 'string') {
      try {
        unref(column).changFun = new Function("record", "formObj", "gridList", `return (${unref(column)['changFun']})(record,formObj,gridList);`);
      } catch (e) {
        console.error(e)
      }
    }
  }

  function initRecordByDefSet({itemDb, newObj, pModelObj, orginObj = {}}) {
    if (itemDb.orginDefValFrom === 'userDef') {
      newObj[itemDb.targetPropId] = itemDb.orginDefVal;
    }
    if (itemDb.orginDefValFrom === 'formField') {
      newObj[itemDb.targetPropId] = unref(pModelObj)[itemDb.formFieldId];
    }
    if (itemDb.orginDefValFrom === 'selRecord') {
      if (unref(orginObj)) {
        newObj[itemDb.targetPropId] = unref(orginObj)[itemDb.formFieldId];
      }
    }
  }

  /**
   * 单元格变化
   */
  const changeInput = function (backObj: any, initDefValueFlag = false) {
    changeFlag.value = true;
    validateAll();
    if (unref(column) && unref(column).changFun && typeof unref(column).changFun === 'string') {
      initColChangeFun();
    }
    const dataConfig = unref(column).dataConfig;
    if (unref(dataConfig) && unref(dataConfig).defColList && Array.isArray(unref(dataConfig).defColList)) {
      unref(dataConfig).defColList.forEach((itemDb) => {
        if (unref(record)) {
          initRecordByDefSet({itemDb, newObj: unref(record), pModelObj: {}, orginObj: unref(record)});
        }
      })
    }
    if (unref(dataConfig) && unref(dataConfig).readColList && Array.isArray(unref(dataConfig).readColList)) {
      unref(dataConfig).readColList.forEach((colItem) => {
        const targetColPropId = unref(colItem)?.targetColPropId;
        const sourcePropId = unref(colItem)?.orginPropId || unref(colItem)?.propId;
        if (unref(record) && backObj?.record && targetColPropId && sourcePropId) {
          unref(record)[targetColPropId] = backObj.record[sourcePropId];
        }
      })
    }
    nextTick(() => {
      // 确保我们传递的是正确的record引用
      const updatedRecord = unref(record);
      const newValue = updatedRecord && updatedRecord[unref(column).dataIndex];

      emits('changeCellVal', {
        record: updatedRecord,
        column,
        newVal: newValue,
        initDefValueFlag
      })
      if (unref(gridKey) && updatedRecord?.id) {
        const gridTableStore: any = useGridTableStore();
        const selIds = gridTableStore.getGridSels(unref(gridKey));
        const isSelected = selIds && selIds.includes(updatedRecord.id);
        if (unref(column).changeSelRecordFlag || isSelected) {
          eventBus.emit(GoingUtils.getEventCtlKey(unref(gridKey)) + 'selGridRecordByCode', {
            selId: updatedRecord.id,
            selRecord: updatedRecord,
            selFlag: true
          });
        }
      }
      // 在 nextTick 中调用 executeColEvent，确保 record[dataIndex] 已经更新完成
      executeColEvent({column, record, formDomainObj, emits}, clickEvent, clickEventByItem);
      changeFlag.value = false;
    })
  }

  const getDefPlaceholder = computed(() => {
    return (unref(column).label || unref(column).propName);
  })

  /**
   * 显示标志
   */
  const shoFlagComp = computed(() => {
    if (unref(column).initFun) {
      const aclInfo = {userId: StorageUtils.getSessionItem("curUserId")};
      const funNew = new Function("record", "aclInfo", `return (${unref(column).initFun})(record,aclInfo);`);
      const res = funNew(unref(record), unref(aclInfo));
      if (res != null) {
        return res;
      } else {
        return true;
      }
    }
    return true;
  })


  const formatCellValue = () => {
    const dataIndex = unref(column).dataIndex;
    const val = unref(record)[dataIndex];
    if (val === null || val === undefined || val === '') {
      unref(record)[dataIndex] = '';
      return;
    }
    unref(record)[dataIndex] = formatFloatNumberValue(val, unref(column));
  }

  const blurInput = function () {
    const dataIndex = unref(column).dataIndex;
    const currentVal = unref(record)[dataIndex];
    if (typeof currentVal === 'string') {
      const trimmedVal = currentVal.trim();
      if (trimmedVal !== currentVal) {
        unref(record)[dataIndex] = trimmedVal;
        changeInput({}, false);
      }
    }
    nextTick(() => {
      if (unref(column).events && Array.isArray(unref(column).events) && unref(column).events.length > 0) {
        clickEvent('onBlur', {
          formObj: unref(formDomainObj),
          record: unref(record),
          value: unref(record)[unref(column).dataIndex],
          column: unref(column)
        });
      }
    });
  }

  const blurNumber = function () {
    nextTick(() => {
      const dataIndex = unref(column).dataIndex;
      const beforeVal = unref(record)[dataIndex];
      formatCellValue();
      const afterVal = unref(record)[dataIndex];
      const beforeNum = Number(beforeVal);
      const afterNum = Number(afterVal);
      const bothNaN = Number.isNaN(beforeNum) && Number.isNaN(afterNum);
      if (!bothNaN && beforeNum !== afterNum) {
        changeInput({}, false);
      }
      isUserTyping.value = false;
      if (unref(column).events && Array.isArray(unref(column).events) && unref(column).events.length > 0) {
        clickEvent('onBlur', {
          formObj: unref(formDomainObj),
          record: unref(record),
          value: unref(record)[unref(column).dataIndex],
          column: unref(column)
        });
      }
    });
  }

  const handleInput = function () {
    isUserTyping.value = true;
  }

  onMounted(() => {
    initColChangeFun();
  })

  return {
    executeColEvent,
    blurInput,
    blurNumber,
    changeFlag,
    shoFlagComp,
    validateAll,
    getDefPlaceholder,
    hasError,
    errorMsg,
    changeInput,
    handleInput,
    formatCellValue,
    isUserTyping
  }
}
